import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'reactstrap';

import styles from './styles.module.scss';
import Logo from '../../assets/img/logo.jpeg';
import { logout } from '../../redux/actions/auth';
import Sidebar from '../Sidebar';

const Topbar = ({ children }) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');

  const getInitialSidebarState = () => {
    try {
      const savedState = localStorage.getItem('sidebarOpen');
      return savedState !== null ? JSON.parse(savedState) : false;
    } catch (error) {
      console.error('Error reading sidebar state from localStorage:', error);
      return false;
    }
  };

  const [sidebarOpen, setSidebarOpen] = useState(getInitialSidebarState);

  const handleLogout = () => {
    localStorage.setItem('sidebarOpen', JSON.stringify(false));
    dispatch(logout());
    window.location.href = '/sign-in';
  };

  const toggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);

    // Save sidebar state to localStorage
    try {
      localStorage.setItem('sidebarOpen', JSON.stringify(newState));
    } catch (error) {
      console.error('Error saving sidebar state to localStorage:', error);
    }
  };

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  const mustShow = token ? true : false;

  return (
    <article>
      {mustShow && (
        <section className={styles.topbar}>
          <div className={styles.leftSection}>
            <Button size="md" onClick={toggleSidebar}>
              {sidebarOpen ? (
                <i className="fa fa-chevron-left"></i>
              ) : (
                <i className="fa fa-chevron-right"></i>
              )}
            </Button>
            <div
              className={styles.logo}
              onClick={handleLogoClick}
              style={{ cursor: 'pointer' }}
            >
              <img alt="logo" style={{ width: '100px' }} src={Logo} />
            </div>
          </div>

          <div className={styles.logout}>
            <div className={styles.userInfo}>
              <span className={styles.email}>{email}</span>
              <span className={styles.role}>{role}</span>
            </div>
            <Button size="md" color="danger" onClick={handleLogout}>
              <i className="fa fa-sign-out-alt"></i>
            </Button>
          </div>
        </section>
      )}
      {sidebarOpen && mustShow && <Sidebar />}
      <section
        className={mustShow ? 'content' : ''}
        style={{
          marginLeft: sidebarOpen ? '250px' : '0px',
          marginTop: mustShow ? '65px' : '0px',
        }}
      >
        {children}
      </section>
    </article>
  );
};

export default Topbar;
